import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import Context from './context/DetailsContext';
import { GRIEVANCE_STATUSES, GrievanceItem } from '../../../services/types/Grievance';

const refreshPage = () => {
  setTimeout(() => {
    window.location.reload();
  }, 500);
};

const GrievanceSubtitle = () => {
  const { grievance } = useContext(Context);
  const { t } = useTranslation();

  const getGrievancePhase = ({ grievanceStatus, currentPhaseName }: GrievanceItem) => {
    switch (grievanceStatus) {
      case GRIEVANCE_STATUSES.NOT_APPLICABLE:
        return '-';
      case GRIEVANCE_STATUSES.CLOSED:
        return 'Closed';
      case GRIEVANCE_STATUSES.IN_PROGRESS:
        return t(`grievanceStages.${currentPhaseName}`) || '-';
      default:
        return '-';
    }
  };

  return (
    <>
      {grievance.operationNumber && (
        <Link
          key={grievance.operationNumber}
          to={`/operations/${grievance.operationNumber}`}
          id={grievance.operationNumber}
          className="mt-n2"
          style={{ color: '#0099d6', fontSize: '14px' }}
          onClick={refreshPage}
        >
          <span>{grievance.operationNumber}</span>
        </Link>
      )}
      <div className="page-subtitle">
        <div id="complainantCont" style={{ alignItems: 'baseline', whiteSpace: 'nowrap' }}>
          <span id="complainant" className="bold">{`${t('complainant')}: `}</span>
          {grievance.claimantName}
          <span className="divider">/</span>
        </div>
        <div id="trackTypeCont" style={{ alignItems: 'baseline', whiteSpace: 'nowrap' }}>
          <span id="trackType" className="bold">{`${t('trackType')}: `}</span>
          {grievance.trackType ? grievance.trackType : '-'}
          <span className="divider">/</span>
        </div>
        <div id="stageCont" style={{ alignItems: 'baseline', whiteSpace: 'nowrap' }}>
          <span id="stage" className="bold">{`${t('grievanceStatus')}: `}</span>
          {t(`grievanceStages.${grievance.grievanceStatus}`) || grievance.grievanceStatus}
          <span className="divider">/</span>
        </div>
        <div id="phaseCont" style={{ alignItems: 'baseline', whiteSpace: 'nowrap' }}>
          <span id="phase" className="bold">{`${t('grievancePhase')}: `}</span>
          {getGrievancePhase(grievance)}
        </div>
      </div>
      <div className="page-subtitle">
        <div id="operationnameCont" style={{ alignItems: 'baseline', whiteSpace: 'nowrap' }}>
          <span id="operationname" className="bold">{`${t('operationName')}: `}</span>
          {grievance.operationName ? grievance.operationName : '-'}
        </div>
      </div>
      {grievance.relateds && grievance.relateds.length > 0 && (
        <div className="page-subtitle">
          <span id="relatedGrievanceCont" className="bold">
            {`${t('relatedGrievanceNumber')}:`}&nbsp;
          </span>
          {grievance.relateds.map((r, index) => (
            <React.Fragment key={r.number}>
              {index > 0 && <span className="divider">,&nbsp;</span>}
              <Link
                to={`/grievance-protocol/details/${r.number}`}
                id={r.number}
                className="mt-n2"
                style={{ color: '#0099d6', fontSize: '14px' }}
                onClick={refreshPage}
              >
                <span>{r.number}</span>
              </Link>
            </React.Fragment>
          ))}
        </div>
      )}
      {grievance.primaryGrievanceNumber && (
        <div className="page-subtitle">
          <div id="primaryGrievanceCont" style={{ alignItems: 'baseline', whiteSpace: 'nowrap' }}>
            <span id="primaryGrievance" className="bold">{`${t('primaryGrievance')}: `}</span>
            <Link
              to={`/grievance-protocol/details/${grievance.primaryGrievanceNumber}`}
              id={grievance.primaryGrievanceNumber}
              className="mt-n2"
              style={{ color: '#0099d6', fontSize: '14px' }}
              onClick={refreshPage}
            >
              <span>{grievance.primaryGrievanceNumber}</span>
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default GrievanceSubtitle;
